import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function createInboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.createinboundapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/entryOrder/create"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/gateway/edi/entryOrder/create"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/entryOrder/create"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value: "https://openapi.jtfulfillment.cn/gateway/edi/entryOrder/create"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc90"
            },
            {
              name: "entryOrderCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.entryOrderCodeDesc91"
            },
            {
              name: "customerid",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc92"
            },
            {
              name: "erpOrderCode",
              type: "varchar(51)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.erpOrderCodeDesc93"
            },
            {
              name: "sourceSystem",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceSystemDesc94"
            },
            {
              name: "outBizNo",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.outBizNoDesc95"
            },
            {
              name: "storerKey",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.storerKeyDesc96"
            },
            {
              name: "orderType",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.orderTypeDesc97"
            },
            {
              name: "expectStartTime",
              type: "date",
              require: "N",
              normal: "",
              describe: "apiDocDesc.expectStartTimeDesc98"
            },
            {
              name: "trackNo",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.trackNoDesc99"
            },
            {
              name: "supplierCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.supplierCodeDesc100"
            },
            {
              name: "sourceWarehouseCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceWarehouseCodeDesc101"
            },
            {
              name: "sourceStoreCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceStoreCodeDesc102"
            },
            {
              name: "remark",
              type: "varchar(200)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.remarkDesc103"
            },
            {
              name: "reserved1",
              type: "json",
              require: "N",
              normal: "",
              describe: "apiDocDesc.reserved1Desc104"
            },
            {
              name: "items",
              type: "array",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.itemsDesc105",
              children: [
                {
                  name: "LineNo",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.LineNoDesc106"
                },
                {
                  name: "itemCode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc107"
                },
                {
                  name: "quantity",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.quantityDesc108"
                },
                {
                  name: "inventoryType",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.inventoryTypeDesc109"
                },
                {
                  name: "productDate",
                  type: "String",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.productDateDesc110"
                },
                {
                  name: "expirationDate",
                  type: "String",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.expirationDateDesc111"
                },
                {
                  name: "produceCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc112"
                },
                {
                  name: "batchCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc113"
                },
                {
                  name: "remark",
                  type: "varchar(200)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc114"
                },
                {
                  name: "reserved1",
                  type: "json",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc115"
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "responseitems",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.responseitemsDesc116",
              children: [
                {
                  name: "success",
                  type: "",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.successDesc117"
                },
                {
                  name: "reason",
                  type: "",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.reasonDesc118"
                }
              ]
            },
            {
              name: "message",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.messageDesc119"
            },
            {
              name: "entryOrderCode",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.entryOrderCodeDesc120"
            },
            {
              name: "entryOrderId",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.entryOrderIdDesc121"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "SH.001",
        entryOrderCode: "UPFOS2023052901",
        customerid: "DEV-TEST",
        orderType: "CGRK",
        expectStartTime: "2023-05-10",
        remark: "DEV-TEST",
        trackNo: "123456789",
        supplierCode: "gys",
        items: [
          {
            itemCode: "test-sdflfekfeww-green",
            quantity: 50,
            inventoryType: "ZP",
            productDate: "2023-05-10",
            produceCode: "xxxxx",
            batchCode: "xxxxx",
            remark: "备注"
          }
        ]
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        responseitems: [
          {
            success: "true",
            reason: "",
            message: "响应信息",
            entryOrderCode: "客户订单号",
            entryOrderId: "入库单号"
          }
        ]
      }
    }
  };
}
